<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';

  import ProductCard from '$components/product-card/product-card.svelte';
  import SplitLines from '$components/split-lines.svelte';

  import { shopify } from '$lib/shopify';
  import { isCmsStory } from '$lib/utils/cms';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';

  import type { ProductHighlightStoryblok } from '$types/bloks';
  import type { LanguageCode } from '$gql/storefront/schemas';
  import { lang } from '$lib/lang';
  import { optimalUSCountry, parseCountryAsCode } from '$lib/country';

  export let block: ProductHighlightStoryblok;

  $: handle = isCmsStory(block.product) ? block.product.slug : '';
  $: query = handle
    ? createQuery({
        staleTime: 5 * 60 * 1000,
        queryKey: ['productCard', handle],
        queryFn: async () => {
          return await $shopify.getProductCard({
            handle,
            lang: $lang.toUpperCase() as LanguageCode,
            country: parseCountryAsCode($optimalUSCountry)
          });
        }
      })
    : null;
  $: productData = $query?.data?.product;
</script>

{#if productData}
  <section class="px-2 pt-12 pb-2 lg:px-8 lg:py-16">
    <div
      class="container mx-auto flex flex-col lg:flex-row justify-between gap-8 lg:gap-0"
      use:storyblokEditable={block}
    >
      <div class="w-full lg:w-4/12 flex flex-col gap-2 px-2 lg:px-0">
        <p class="text-3xl font-semibold">{block.title}</p>
        {#if block.text}
          <SplitLines class="text-xl text-primary/80" text={block.text} />
        {/if}
      </div>
      <ProductCard product={productData} class="lg:min-h-[512px]" />
    </div>
  </section>
{/if}
